import { PagamentoAPI } from "@/api/pagamento.api";
import { Pagamento, PayloadPagamento } from '@/models/pagamento';
import { AxiosObservable } from 'axios-observable/dist/axios-observable.interface';

const api = new PagamentoAPI();

const list = (params: any): AxiosObservable<Pagamento[]> => {
  return api.list(params)
}

const show = (id: number): AxiosObservable<Pagamento> => {
  return api.show(id)
}

const create = (body: PayloadPagamento): AxiosObservable<Pagamento> => {
  return api.createPagamento(body);
}

const createPaymentGroup = (body: any): AxiosObservable<any> => {
  return api.createPaymentGroup(body)
}

const process = (id: string, body: any): AxiosObservable<Pagamento> => {
  return api.process(id, body)
}

export default {
  list,
  show,
  create,
  createPaymentGroup,
  process
}
